import { render, staticRenderFns } from "./MyMenu.vue?vue&type=template&id=2cccafe5&scoped=true&"
import script from "./MyMenu.vue?vue&type=script&lang=js&"
export * from "./MyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyMenu.vue?vue&type=style&index=0&id=2cccafe5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccafe5",
  null
  
)

export default component.exports